<!-- 封面 -->
<template>
  <div class="cover-com">
    <div class="top-box">
      <img :src="imgUrlMap.login2" class="top-img" alt="" />
      <img :src="imgUrlMap.logo" class="logo" alt="" />
      <img :src="imgUrlMap.topHappy" class="top-happy" alt="" />
      <img :src="imgUrlMap.top37" class="top-37" alt="" />
    </div>

    <img :src="imgUrlMap.login1" class="cover-bg" alt="" />
    <!-- 信戳 -->
    <img :src="imgUrlMap.login3" class="stamp" @click="openCover" alt="" />
    <!-- 账号 -->
    <transition name="fade">
      <div v-if="process === 0" class="account-content">
        <!-- <van-form @submit="onSubmit"> -->
        <!-- failed -->
        <van-form @submit="onSubmit">
          <div class="row">
            <van-field
              v-model.trim="formData.phone"
              placeholder="请输入您的手机号码"
              :maxlength="11"
              :left-icon="imgUrlMap.input1"
              :rules="[
                { validator: validatorPhone, message: '请输入正确的手机号码' },
              ]"
            />
          </div>
          <div class="row code-row">
            <van-field
              type="number"
              v-model.trim="formData.code"
              placeholder="请输入验证码"
              maxlength="6"
              :left-icon="imgUrlMap.input2"
              :rules="[
                { validator: validatorCode, message: '请输入正确的验证码' },
              ]"
            />
            <van-button @click="getCode" :disabled="codeBtnDisabled">{{
              countDown == 0 ? "获取验证码" : `${countDown}s`
            }}</van-button>
          </div>
          <div class="btn-row">
            <van-button
              round
              block
              color="#000"
              :loading="btnDisabled"
              native-type="submit"
            >
              登 录
            </van-button>
          </div>
        </van-form>
      </div>
    </transition>
    <!-- 星星区域 -->
    <div class="start-region-box" v-if="process === 1">
      <StarRegion :imgUrlMap="imgUrlMap" ref="starRegionRef" />
    </div>
  </div>
</template>
<script setup>

import { reactive, ref, computed, onBeforeMount, onMounted, defineProps, defineExpose, defineEmits, nextTick } from 'vue'
import { useRoute, useRouter, } from "vue-router";
import { getSignInPages, } from '@/api/signInGift.js'
import { Toast } from 'vant';
import { sendVercode, checkWhite, } from '@/api/womensDay'
import anime from 'animejs/lib/anime.es.js';
import StarRegion from './starRegion';
import { setCookie } from '@/utils/cookie'

const route = useRoute();
const router = useRouter();

const props = defineProps({
  // 封面图片地址
  imgUrlMap: {
    type: Object,
    default: () => { }
  },
  process: {
    type: Number,
    default: undefined
  },
})
const emit = defineEmits(["setProcess", "setUserInfo", 'openMusic']);

// 校验函数返回 true 表示校验通过，false 表示不通过
const validatorPhone = (val) => /1\d{10}/.test(val);
const validatorCode = (val) => /\d{6}/.test(val);
const starRegionRef = ref(null)
const formData = reactive({
  phone: '',
  code: '',
})
const codeBtnDisabled = ref(false)
const btnDisabled = ref(false)
const countDown = ref(0)
const timer = ref(null)

onMounted(() => {
  // coverInitStartDate()
  // stampAnimation()
});

const getCode = () => {
  let obj = {
    phone: formData.phone,
  }
  codeBtnDisabled.value = true;
  countDown.value = 60;
  sendVercode(obj).then(() => {
    timer.value = setInterval(() => {
      if (countDown.value <= 0) {
        codeBtnDisabled.value = false;
        clearTimer()
      } else {
        countDown.value--
      }
    }, 1000)
  }).catch(res => {
    Toast(res.message)
    codeBtnDisabled.value = false;
    countDown.value = 0;
  })
}
const clearTimer = () => {
  clearInterval(timer.value)
  timer.value = null;
}
// 提交
const onSubmit = () => {

  btnDisabled.value = true
  let obj = {
    phone: formData.phone,
    vercode: formData.code,
  }
  codeBtnDisabled.value = true;
  checkWhite(obj).then((res) => {
    // console.log(res, 'res=');
    setCookie('womensDayToken', res.data.token)
    setCookie('womensDayInfo', JSON.stringify(res.data))

    btnDisabled.value = false
    emit("setUserInfo", res.data) // 登录成功,设置用户信息
    // setTimeout(() => {
    //   coverInitStartDate()
    //   stampAnimation()
    // }, 600)
  }).catch(res => {
    Toast(res.message)
    btnDisabled.value = false
  })
}
const beginAnimation = () => {
  coverInitStartDate()
  stampAnimation()
}
// 开启信封
const openCover = () => {
  console.log('开启信封');
  if (props.process === 1) { // 登录成功后才可点击
    anime.remove('.stamp'); // 移除信戳动画
    coverStartDisappear() // 星星结束动画，消失
    openCoverAnimation()
    emit("openMusic",) // 开启音乐
  }
}

// 信戳默认动画
const stampAnimation = () => {
  anime({
    targets: ['.stamp'],
    easing: 'easeInOutSine',
    delay: 1000,
    loop: true,
    duration: 800,

    // headShake
    // keyframes: [
    //   { translateX: 0 },
    //   { translateX: -6, rotateY: -9 },
    //   { translateX: 5, rotateY: 7 },
    //   { translateX: 3, rotateY: -5 },
    //   { translateX: 2, rotateY: 3 },
    //   { translateX: 0, rotateY: 0 },
    // ],
    // swing
    keyframes: [
      { translateX: 0, translateY: 0, translateZ: 1, rotate: 15 },
      { translateX: 0, translateY: 0, translateZ: 1, rotate: -10 },
      { translateX: 0, translateY: 0, translateZ: 1, rotate: 5 },
      { translateX: 0, translateY: 0, translateZ: 1, rotate: -5 },
      { translateX: 0, translateY: 0, translateZ: 1, rotate: 0 },
    ],
  })
}

// 开启信封动画
const openCoverAnimation = () => {
  anime({
    targets: ['.stamp'],
    // rotate: [0, 360], // 旋转360度
    rotate: '1turn',
    scale: [1, 0], // 从1缩小到0
    opacity: [1, 0], // 从1变透明
    easing: 'easeInOutSine',
    duration: 400, // 持续800ms
  })
  anime({
    targets: ['.top-box',],
    translateY: '-100%',
    easing: 'easeInOutSine',
    duration: 800,
    delay: 500
  })
  anime({
    targets: ['.cover-bg'],
    translateY: '100%',
    easing: 'easeInOutSine',
    duration: 800,
    delay: 1300,
    complete: () => {
      emit("setProcess", 2) // 信封打开后，消失
    }
  })
}
// 星星数据数初始化
const coverInitStartDate = () => {
  starRegionRef.value?.initStartDate(30)
}
// 星星消失
const coverStartDisappear = () => {
  starRegionRef.value?.startDisappear()
}

defineExpose({ beginAnimation })


</script>
<style  lang="less" scoped>
.cover-com {
  width: 100vw;
  height: 100vh;
  position: relative;
  .cover-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .top-box {
    width: 100%;
    height: 280px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    .top-img {
      position: absolute;
      top: -50px;
      left: 0;
      width: 100%;
    }
    .logo {
      position: absolute;
      top: 16px;
      left: 15px;
      width: 103px;
    }
    .top-happy {
      position: absolute;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      width: 180px;
    }
    .top-37 {
      position: absolute;
      top: 155px;
      left: 50%;
      transform: translateX(-50%);
      width: 200px;
    }
  }
  .stamp {
    width: 167px;
    height: auto;
    position: absolute;
    top: 180px;
    left: 106px;
    z-index: 2;
  }
  .account-content {
    position: absolute;
    top: 41%;
    left: 10px;
    z-index: 3;
    box-sizing: border-box;
    padding: 90px 28px 80px 28px;
    width: 95%;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 20px;
    /deep/ .van-cell {
      border-radius: 28px;
      background: none;
    }
    /deep/ .van-field__body {
      line-height: 2.5;
    }
    /deep/ .van-field__error-message {
      margin-top: 5px;
    }
    /deep/ .van-field__left-icon {
      margin-right: 12px;
    }
    /deep/ .van-icon__image {
      margin-top: 10px;
    }
    .row {
      margin-bottom: 20px;
      height: 55px;
      background: #ffffff;
      border-radius: 28px;
      border: 1px solid #424e31;
      font-size: 16px;
    }
    .code-row {
      display: flex;
      align-items: flex-start;
      .van-button {
        margin-top: 5px;
        padding: 0 10px;
        width: 55%;
        font-size: 16px;
        border: none;
        color: #000000;
        background: none;
      }

      // .van-cell::after {
      //   right: 0;
      //   border-bottom: none;
      // }
    }
    .btn-row {
      margin-top: 30px;
      button {
        height: 55px;
        font-weight: 600;
        font-size: 21px;
      }
    }
  }
  .start-region-box {
    width: 90%;
    height: 100vh;
    position: relative;
    top: 0px;
    left: 5%;
    z-index: 1;
    pointer-events: none;
  }
}
</style>
